import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app.store';

export interface GridCellState {
  rowId: string;
  columnId: string;
  isSaving: boolean;
  isNewlyUpdated: boolean;
  isInputDirty?: boolean;
  prevValue: number;
  currValue: number;
  valuePostUpdate?: number;
}

const initialState: GridCellState[] = [];

const gridCellSlice = createSlice({
    name: 'gridCell',
    initialState,
    reducers: {
      addGridCells: (state, action: PayloadAction<GridCellState[]>) => {
        state.push(...action.payload);
      },
      updateGridCells: (state, action: PayloadAction<GridCellState[]>) => {
        action.payload.forEach(newCell => {
          const index = state.findIndex(cell => cell.rowId === newCell.rowId && cell.columnId === newCell.columnId);
          if (index !== -1) {
            // Only overwrite valuePostUpdate if it is provided (not null/undefined)
            state[index] = {
              ...state[index],
              ...newCell,
              valuePostUpdate: newCell.valuePostUpdate !== undefined ? newCell.valuePostUpdate : state[index].valuePostUpdate
            };
          } else {
            state.push(newCell);
          }
        });
      },
      clearGridCells: (state) => {
        state.forEach(cell => {
          cell.isSaving = false;
          cell.isNewlyUpdated = false;
          cell.isInputDirty = false;
        });
      },
      resetGridCells: (state) => {
        state.forEach(cell => {
          if (cell.isInputDirty) {
            cell.isSaving = false;
            cell.isNewlyUpdated = false;
            cell.isInputDirty = false;
            cell.currValue = cell.valuePostUpdate? cell.valuePostUpdate: cell.prevValue; // Reset current value to previous value
          }
        });
        return state;
      },
    },
});

export const { addGridCells, updateGridCells, clearGridCells, resetGridCells } = gridCellSlice.actions;

export const selectGridCells = (state: RootState) => state.gridCell;

export const selectGridCellByRowIdAndColumnId = (rowId: string, columnId: string) => {
  return (state: RootState) => {
    const gridCells = selectGridCells(state);
    return gridCells.find(cell => cell.rowId === rowId && cell.columnId === columnId);
  };
};

export const selectGridCellByRowId = (rowId: string) => {
  return (state: RootState) => {
    const gridCells = selectGridCells(state);
    return gridCells.filter(cell => cell.rowId === rowId);
  }
}

export default gridCellSlice.reducer;
